import { FC } from 'react';
import { useHistory } from 'react-router';

import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import useToast from 'components/ToastProvider/useToast';
import { ClientFromList } from 'features/Work/pages/Clients/pages/List/hooks/queries/useGetClients';

import { useClientModals } from '../..';
import { useDeleteClientMutation } from './hooks/useDeleteClientMutation';
import locales from './locales';

// Form in modal to delete a client

export type DeleteClientModalProps = Pick<ClientFromList, 'clientId' | 'name'>;

const DeleteClientModal: FC<DeleteClientModalProps> = ({ clientId, name }) => {
  const { hideModal } = useClientModals();
  const { showToast } = useToast();
  const history = useHistory();

  const [deleteClient, { loading }] = useDeleteClientMutation();

  const onSubmit = async () => {
    await deleteClient({
      variables: { input: { clientId } },
    });

    showToast({
      message: locales.formatString(locales.successMessage, name),
      title: locales.successTitle,
      type: 'success',
    });

    hideModal();
    history.replace('/work/clients');
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Title>
          {locales.formatString(locales.modalTitle, name)}
        </SunshineModal.Title>

        <Text>{locales.formatString(locales.modalSubtitle, name)}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button onClick={hideModal} variant="inline-secondary">
          {locales.cancel}
        </Button>

        <Button
          icon="arrow-right"
          isLoading={loading}
          onClick={onSubmit}
          type="submit"
          variant="danger"
        >
          {locales.confirmDelete}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default DeleteClientModal;
